/**
 * @author Andrés Camilo Ferreira Rodríeguez
 * @Copyright (c) Infotrack. All rights reserved.
 */
import { IRespuesta, IRespuestaPaginada } from '@infotrack/presentacion-transversales/interfacesComunes';
import manejadorRest from '@infotrack/presentacion-utilitarios/manejadorRest';
import { Console } from 'console';
import { negocio } from '../../conexiones';
import IItemFiltroPaginado from './entidades/itemFiltroPaginado';
import IItemMovimiento from './entidades/itemMovimiento';
import IMovimientoCompuesto from './entidades/movimientoCompuesta';
import IMovimientoItemSerial from './entidades/movimientoItemSerial';
import IPaginadorMovimientosCompuesto from './entidades/paginadorMovimientosCompuesto';

export default class ModeloMovimiento {   ;
    public consultarMovimientosCompuestoFiltro(parametros: IPaginadorMovimientosCompuesto) {     
           return manejadorRest<IRespuestaPaginada<IMovimientoCompuesto>>(
            () => negocio.post('Movimiento/ConsultarMovimientosCompuestoFiltro', parametros),
            true
        );
    }

    public consultarMovimientosSinDocumentoDetalle({ paginador, filtro }: IPaginadorMovimientosCompuesto) {
        return manejadorRest<IRespuestaPaginada<IMovimientoCompuesto>>(
            () => negocio.post('Movimiento/ConsultarMovimientosSinDocumentoDetalle', { paginador, filtro }),
            true
        );
    }

    public consultarItemsMovimientosFiltro(filtros: IItemFiltroPaginado) {
        return manejadorRest<IRespuestaPaginada<IItemMovimiento>>(
            () => negocio.post('GestionDocumentosMovimiento/ConsultarItemsMovimientosFiltro', filtros),
            true
        );
    }

    public consultarSaldoCompuestoFiltro(parametros: IPaginadorMovimientosCompuesto) {
        return manejadorRest<IRespuestaPaginada<IMovimientoCompuesto>>(
            () => negocio.post('Movimiento/ConsultarSaldoCompuestoFiltro', parametros),
            true
        );
    }

   
}
